import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchLeadList = ({commit}) => {
    commit('toggleLoadingState', true)
    axios.get('/appAdmin/lead/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setLeadList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchLeadData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/lead/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setLeadData', res.data.response)   
            router.push('/leads/form/')
            
        } else {
            commit('resetLeadData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitLeadData = ({commit, dispatch}, payload) => {

    if(payload.first_name.length === 0 
            || payload.last_name.length === 0 
                || payload.country_id === 0  
                    || payload.mobile_number.length === 0
                        || payload.brand_name.length === 0 
                            || payload.rep_id === null) {
        commit('displayMessageAlert', {message: 'Please provide all information!!!', type: 'Error'})
        return
    }

    commit('toggleLoadingState', true)
    
    axios.post('/appAdmin/lead/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push('/leads')
            } else {
                dispatch('fetchLeadData', {id: payload.id})
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteLead = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/lead/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            dispatch('fetchLeadList')
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/leads/actions.js